import { gql } from 'graphql-request'

export const GET_WRITER_SALES_ANALYTICS_OVERVIEW = gql`
  query GetWriterSalesAnalyticsOverview(
    $getWriterSalesAnalyticsOverviewInput: GetWriterSalesAnalyticsOverviewInput!
  ) {
    getWriterSalesAnalyticsOverview(
      getWriterSalesAnalyticsOverviewInput: $getWriterSalesAnalyticsOverviewInput
    ) {
      bookTitle
      bookType
      sales
      donation
      viewCount
      likeCount
      shelfAddedCount
      commentCount
      genderDetail {
        maleReader
        femaleReader
        otherReader
      }
      ageDetail {
        ageBelowFifthteen
        ageBetweenSixteenAndTwenty
        ageBetweenTwentyoneAndThirty
        ageBetweenThirtyoneAndForty
        ageBetweenFortyoneAndFifty
        otherAge
      }
    }
  }
`
